const OPTION_STATES = {
  IS_SELECTED: 'IsSelected',
  IS_ACTIVE: 'IsActive',
};

export default OPTION_STATES;
